export default "__VITE_ASSET__eb232373__"